import owaServiceFeatures from 'owa-service/lib/owaServiceFeatures';

// Please insert new features in alphabetical order, to preserve readability and reduce chance of merge conflicts
const features = {
    ...owaServiceFeatures,
    'addin-attachmentApis': {},
    'addin-autoRunAddins': {},
    'addin-centerAlignedICSEnabled': {},
    'addin-complianceVerification': {},
    'addin-delegateAccess': {},
    'addin-getAccessTokenAsync-api': {},
    'addin-inClientStoreDefaultAddinsEnabled': {},
    'addin-inClientStoreEnabled': {},
    'addin-inClientStorePinnableExperience': {},
    'addin-inClientStoreSendFeedbackEnabled': {},
    'addin-itemSendEvent': {},
    'addin-launchDatapoint': {},
    'addin-oteljs': {},
    'addin-persistentTaskPane': {},
    'addins-launchAddinsFromUrl': {},
    'an-client-error': {},
    'an-client-event': {},
    'an-client-network-request': {},
    'an-client-verbose-wl': {},
    'an-full-logging': {},
    'an-no-sample-ppe': {},
    'an-sampled-client-event': {},
    'an-log-assets': {},
    'auth-PremiumDashboard': {},
    'auth-PremiumDashboardApril': {},
    'auth-PremiumSupportControl': {},
    'auth-PremiumSupportTreatment': {},
    'auth-ServiceWorkerEdge': {},
    'auth-ServiceWorkerSafari': {},
    'auth-activityFeed': {
        description: 'Enables the activity feed panel',
    },
    'auth-activityFeedAtMentionsProcessor': {
        description: 'Enables the activity feed mention processor',
    },
    'auth-cloudCache': {},
    'auth-connectedAccounts': {},
    'auth-cutOverSoftLanding': {
        description: 'Allows the React Mail cut over FRE to be shown',
    },
    'auth-domainConnect': {},
    'auth-domainConnect-popout': {},
    'auth-domainConnectDemandGen': {},
    'auth-forwardingNotice': {
        description: 'Shows the forwarding notice toast notification at app startup',
    },
    'auth-getStarted': {},
    'auth-leftNavInAppUpsell': {},
    'auth-leftNavPremiumUpsell': {},
    'auth-leftNavPremiumUpsellNoCCTreatment': {},
    'auth-LeftNavUpsellFreeServicesTreatment': {},
    'auth-LeftNavUpsellFreeServicesControl': {},
    'auth-linkedInOption': {},
    'auth-mobileDevice': {},
    'auth-PremiumTravelActivateRamp': {},
    'auth-PremiumTravelExpcf': {},
    'auth-PremiumTravelExp': {},
    'auth-PremiumTravelUpsellRamp': {},
    'auth-PremiumTransferDomainTab': {},
    'auth-TravelDashboardEnabled': {
        description: 'Enables the travel Savings dashboard for premium users',
    },
    'auth-openAnotherMailbox': {
        description: 'Enables the "Open another mailbox" dialog menu item for explicit login',
    },
    'auth-realtimeEmail': {
        description: 'Enables the iris call to send marketing emails for better visibility',
    },
    'auth-safelinksOptionControl': {},
    'cal-cacheDiagnostics': {
        description:
            'Flight to rollout logging of calendar cache diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'auth-calendar-serviceworker-cache': {
        description: 'Enables the service worker cache for the calendar app.',
    },
    'cal-CalendarDayListComponent': {},
    'cal-addCalendarFromDirectory': {},
    'cal-addCalendar-teamSnap': {
        description: 'Enables the ability to add TeamSnap account',
    },
    'cal-addins': {},
    'cal-advancedRoomBooking': { description: 'cal-mf' },
    'cal-agendaMail-feedback': {},
    'cal-agenda': {},
    'cal-automatic-replies': {},
    'cal-birthday-settings': {},
    'cal-categories': {},
    'cal-css-variables': {},
    'cal-dimPastEvents': {},
    'cal-dnd-icsfile': {
        description:
            'Flight to enable drag and drop of ics file on calendar to lauch Discover Calendar with Import from File panel',
    },
    'cal-event-duration-setting': {},
    'cal-event-invitation-setting': {},
    'cal-groupCalendarSetColor': {},
    'cal-groupsCalendar': {},
    'cal-ignoreSkipSendingMeetingInviteToGroup': {},
    'cal-highlightPastDays': {},
    'cal-ics-preview': {},
    'cal-assumeTzOffsetFromCalendarItem': {
        description:
            "Assumes the time zone offset in a calendar item is correct for the user's time zone.",
    },
    'cal-intelligenceOption': {
        description: 'Whether to show intelligence features in Options',
    },
    'cal-interestingCalendar': {},
    'cal-linkedCalendarEntry': {},
    'cal-meetingInsights': {},
    'cal-mf-agendaMailOption': {
        description: 'Flight to enable agenda mail option',
    },
    'cal-mf-automatic-replies-notification': {
        description: 'Flight to enable the automatic replies notification',
    },
    'cal-mf-insightsInUpNext': {
        description: 'Flights to enable the insights in Up Next',
    },
    'cal-mf-attendeeBusyConfirmationFC': {
        description:
            'Flight to show a confirmation dialog when a meeting invite is sent with at least one busy attendee in full compose.',
    },
    'cal-mf-attendeeBusyConfirmationQC': {
        description:
            'Flight to show a confirmation dialog when a meeting invite is sent with at least one busy attendee in quick compose.',
    },
    'cal-mf-eventDurationLeft': {
        description:
            'Flight to show the event duration dropdown in full compose (on the left side of start time)',
    },
    'cal-mf-eventDurationRight': {
        description:
            'Flight to show the event duration dropdown in full compose (on the right side of start time)',
    },
    'cal-mf-hideAttendeeList': {
        description: 'Flight to enable showing the hide attendee list option in calendar compose',
    },
    'cal-mf-locationBusyConfirmation': {
        description:
            'Flight to pop-up a confirm dialog, on meeting updates, when the location is busy in the new time slot.',
    },
    'cal-mf-locationCommonWell': {},

    'cal-mf-locationWellShowFreeBusy': {
        description:
            'Flight to enable displaying LocationWell pills with a lower right icon showing FB status',
    },
    'cal-mf-locationwellSearchByCity': {
        description: 'Flight to show room suggestions based on city search.',
    },
    'cal-mf-popoutReadForm': {
        description: 'Used to open conflict calendar item in popout window from mail reading pane',
    },
    'cal-mf-proposeNewTime': {
        description:
            'Flight to enable new proposed new time experience in Mail, i.e accepting proposed new time in meeting response or proposing a new time from a meeting request from both Mail and Calendar',
    },
    'cal-mf-quickComposeMergedEvent': {
        description: 'Merge appointment and meeting controls into one UI',
    },
    'cal-mf-recipientWell': {
        description:
            'Add recipient well in Quick Compose so we can add attendees and create a meeting there',
    },
    'cal-mf-timeSuggestions': {
        description: 'Flight to show CAS suggestions in the compose form',
    },
    'cal-mf-meetingMessageConflictsTimePanel': {
        description: 'Flight to show meeting message conflicts in time panel',
    },
    'cal-mf-newTimeZonePicker': {
        description: 'Replaces the plain time zone picker with a search-by-city smart field',
    },
    'cal-mf-timezoneinsights': {},
    'cal-mf-availabilityForRecurrence': {
        description: 'Flight to request free busy for recurring meetings in Location Well',
    },
    'cal-mf-defaultRoomsFromLasInRoomPanel': {
        description:
            'Flight to use LAS as the default room provider in the room panel when no filters are selected',
    },
    'cal-mf-diagnostics': {
        description:
            'Flight to rollout logging of calendar forms diagnostics.  This flight should always be in SDF only, Otherwise we will log this unnecessarily for customers',
    },
    'cal-mf-rsvpModel': {
        description: 'Flight to show the new RSVP model (Yes/No/Maybe) underneath notes editor',
    },
    'cal-mf-mailCalendarCard': {
        description: 'Flight to enable the calendar card in mail reading pane',
    },
    'cal-mf-mailCalendarCard-miniCal': {
        description: 'Flight to enable the mini calendar in the calendar card in mail reading pane',
    },
    'cal-mf-quickComposeOOF': {
        description: 'Flight to enable OOF tab in quick compose',
    },
    'cal-mf-readingPaneShyHeader': {
        description: 'Flight to enable the shy header in reading pane',
    },
    'cal-notifications-expandCalendarEvent': {},
    'cal-personalbookingpage': {},
    'cal-pbp-option': {
        description: 'Enabled personal booking page for user',
    },
    'cal-ppf-celebration': {},
    'cal-print': {},
    'cal-publishing-settings': {},
    'cal-react': {},
    'cal-mf-recurringBookingOutOfPolicyInfoBar': {
        description:
            'Flight to show InfoBar texts to users to indicate room booking will be declines because of Out Of Window policy.',
    },
    'cal-recurrenceThisDateForward': { description: 'cal-mf' },
    'cal-relatedContent': {
        description:
            'OWS Prime API call to fetch related content when opening details panel cal-mf',
    },
    'cal-relatedContent-filesAndEmailsUX': {
        description:
            'Whether to show the related files and emails inside the insights container cal-mf',
    },
    'cal-schedulingAssistantAttendeeColors': {},
    'cal-schedulingAssistantGradientColors': {},
    'cal-schedulingAssistantSpacedLegend': {},
    'cal-schoolCalendars': {},
    'cal-sea-addCalendarQuickAction': {},
    'cal-sea-clientSide': {},
    'cal-sea-contextFeedback': {},
    'cal-sea-qf-history-people': {
        description:
            'When enabled, calendar search QF will include history and people suggestions.',
    },
    'cal-sea-query': {},
    'cal-sharing': {},
    'cal-sharing-settings': {},
    'cal-showRoomBookingCapabilities': { description: 'cal-mf' },
    'cal-splitView': {},
    'cal-stickyNotesFolder': {},
    'cal-surface-boldColorTheme': {},
    'cal-surface-declinedMeetings': {},
    'cal-surface-discover-calendars-experiment': {},
    'cal-surface-itemExpand': {},
    'cal-surface-notificationBar': {},
    'cal-surface-refresh': {},
    'cal-surface-refresh-addCalendar': {},
    'cal-surveyCancelMeetBucket': {
        description: 'Calendar survey bucket triggered by canceling 1 meeting',
    },
    'cal-surveyCreateApptBucket': {
        description: 'Calendar survey bucket triggered by creating 2 appointments',
    },
    'cal-surveyCreateMeetBucket': {
        description: 'Calendar survey bucket triggered by creating 2 meetings',
    },
    'cal-surveyUpdateApptBucket': {
        description: 'Calendar survey bucket triggered by updating 1 appointment',
    },
    'cal-surveyUpdateMeetBucket': {
        description: 'Calendar survey bucket triggered by updating 2 meetings',
    },
    'cal-surveyViewEventBucket': {
        description:
            'Calendar survey bucket triggered by viewing 2 events via details, peek, or meeting card',
    },
    'cal-truTime': {
        description: 'Feature to expose TruTime settings under Availability option for calendar',
    },
    'cal-multiAccounts': {
        description: 'Feature to expose multi accounts capability for owa calendar',
    },
    'cal-txp-editableCard': {},
    'cal-txp-emailDonation': {},
    'cal-txp-griffin': {},
    'cal-txp-inferencesDSAT': {},
    'cal-txp-invoice': {},
    'cal-txp-optionsV2': {},
    'cal-txp-serviceReservation': {},
    'cal-weather-addLocations': {},
    'cmp-darkMode': {
        description: 'Enables the dark compose experience.',
    },
    'cmp-darkModeToggle': {
        description:
            'Exposes a dark mode toggle to switch the editor between dark mode and light mode.',
    },
    'cmp-delaySend': {
        description: 'Enables the Delay/Undo send feature',
    },
    'cmp-dictation': {
        description: 'Flag to turn on dictation in compose',
    },
    'cmp-downgradeRawCED': {
        description: 'Downgrade editor to raw CED for debugging',
    },
    'cmp-editorPerfMeasure': {
        description: 'Measure the perf of editor in compose',
    },
    'cmp-encryption': {},
    'cmp-clp': {
        description:
            'Whether the clp is enable by tenant. When flag is enabled, each email will be given a sensitivity level and the encryption is applied through labeling instead of the RMS Templates',
    },
    'cmp-hipCheckModal': {
        description:
            'Whether or not to use a modal for the hip check instead of a tab (spam suspicion / account verification)',
    },
    'cmp-hipCheckVendorModal': {
        description: 'Whether the cmp-hipCheckModal should be provided by a vendor',
    },
    'cmp-hipCheckChallengeOnSendFail': {
        description:
            'Whether the cmp-hipCheckModal should be presented immediately on wascl send failure',
    },
    'cmp-implicitgroups': {
        description: 'Implicit group suggestion in mail compose find control',
    },
    'cmp-logOnFrameDropWhileTyping': {
        description: 'Log a datapoint on when a frame is dropped while typing',
    },
    'cmp-mailtips': {},
    'cmp-manageIRM': {
        description: 'Enabled the UI to manage the IRM template applied to a message',
    },
    'cmp-policyTips': {
        description:
            'Enables the fetching of, managing of, and displaying of policyTips for enterprise.',
    },
    'cmp-prague': {
        description:
            'Enables the prague plugin, a plugin that detects prague links and embeds them into the compose surface.',
    },
    'cmp-pragueAnyLink': {
        description:
            'Disables the checking system for potential prague links, treating every link as a potential prague link.',
    },
    'cmp-quickSwitcher': {
        description: 'Toolbar for moving quickly between areas of the app and running commands',
    },
    // TODO #33638 This is for a mail feature, but has to be in client-controls because it is used in
    // CustomSurfaceAction, which does not support a client repo adding additional custom surface actions.
    'cmp-requestDeliveryReceipts': {
        description: 'Toggles whether the UI for requesting Delivery Receipts is shown',
    },
    // TODO #33638 This is for a mail feature, but has to be in client-controls because it is used in
    // CustomSurfaceAction, which does not support a client repo adding additional custom surface actions.
    'cmp-requestReadReceipts': {
        description: 'Toggles whether the UI for requesting Read Receipts is shown',
    },
    'cmp-ribbonBIUS': {
        description: 'Places strikethrough with Bold, Italic, and Underline',
    },
    'cmp-ribbonRemoveFormatAtFront': {
        description: 'Places Remove Format at the front of the ribbon with Format Painter',
    },
    'cmp-ribbonStickyUndo': {
        description:
            'Always display undo as the last non-overflow item on the compose editor ribbon',
    },
    'cmp-selfAsYou': {},
    'cmp-setMessageSensitivity': {
        description: 'Toggles whether the UI for setting message sensitivity is shown',
    },
    'cmp-smime': { description: 'Toggles whether S/MIME feature is enabled in compose form' },
    'cmp-smimeAdminSettings': {
        description: 'Toggles whether S/MIME admin/user settings is respected in compose form',
    },
    'cmp-upgradeCompose': {
        description: 'Loads the editor before retrieving the quoted body in compose',
    },
    'doc-attachment-contextualSharingTips': {},
    'doc-attachment-usePrimarySmtpAddressForMailboxId': {},
    'doc-attachment-documentThumbnail': {},
    'doc-attachment-editingVisualFeature': {},
    'doc-attachment-expiringLinkImprovements': {},
    'doc-attachment-referenceAttachmentExpiration': {},
    'doc-attachment-routingKeyAadSmtp': {},
    'doc-attachment-routingKeyMsa': {},
    'doc-attachment-routingKeyPuid': {},
    'doc-attachment-sharingDialog': {},
    'doc-attachment-sharingInfoFailureTip': {},
    'doc-attachment-sharingLinkInfoOWSPrimeService': {},
    'doc-attachment-sharingTips': {},
    'doc-attachment-upsellEntryPoint': {},
    'doc-attachment-urlEncodeRoutingKey': {},
    'doc-link-accessibility': {},
    'doc-brandsSubscriptions': {},
    'doc-link-attachAsCopy': {},
    'doc-link-calendar': {},
    'doc-link-editingVisualFeature': {
        description:
            'if enabled the beautified link would be highlighted to show if it is in edit mode or in selected mode',
    },
    'doc-filePicker-groupFiles': {},
    'doc-filePicker-mailMessageAttachment': {},
    'doc-filePicker-mailMessageSearch': {},
    'doc-filePicker-oneDriveConsumerForO365': {},
    'doc-filePicker-oneDriveProClientCalls': {},
    'doc-filePicker-oneDriveProRecentFiles': {},
    'doc-filepicker-preload': {},
    'doc-filePicker-sharedWithMeImprovements': {},
    'doc-filePicker-thirdPartyProviderClientCalls': {},
    'doc-fileProvider-facebook': {},
    'doc-fileProvider-wopiClient': {},
    'doc-fileshub': {},
    'doc-fileshub-combineFilesandImages': {
        description:
            'if enabled files and images are shown together in fileshub instead of being shown in separate tabs',
    },
    'doc-SharePoint-dogfoodUser': {},
    'doc-sharepoint-link-preview': {},
    'doc-sharepoint-serviceGeneratedLinkTelemetry': {},
    'doc-SxS-commandBarStyleUpdate': {},
    'doc-SxS-itemAttachment': {},
    'doc-SxS-jsApi-ODB-Core': {},
    'doc-SxS-jsApi-ODB-Word': {},
    'doc-SxS-jsApi-ODB-Excel': {},
    'doc-SxS-jsApi-ODB-PowerPoint': {},
    'doc-SxS-jsApi-ODB-Links': {},
    'doc-SxS-pdfJsPreview': {},
    'doc-SxS-pdfJsPreviewDefaultInEdge': {},
    'doc-SxS-pdfJsPreviewDefaultInFirefox': {},
    'doc-SxS-printImage': {},
    'doc-SxS-printPdf': {},
    'doc-SxS-saveToCloud': {},
    'doc-SxS-V2': {},
    'doc-SxS-Wac-Survey': {},
    'ext-timeExpressionHighlight': {},
    'feedback-ideas-pane': {},
    'feedback-new-consumer-recruitment': {},
    'fms-dialog': {},
    'fms-dialog-action': {},
    'fwk-ads': {},
    'fwk-ads-callBingTopt': {},
    'fwk-ads-detectAdBlocker': {},
    'fwk-ads-disableDefaultPG': {},
    'fwk-ads-disableFallback': {},
    'fwk-ads-exp2-RuntimeBypass': {},
    'fwk-ads-exp2-StopStampUserOption': {},
    'fwk-ads-exp2-DisplayOffNativeOff': {},
    'fwk-ads-exp2-DisplayOffNativeOther': {},
    'fwk-ads-exp2-DisplayOffNativeInbox': {},
    'fwk-ads-exp2-DisplayOnNativeOff': {},
    'fwk-ads-exp2-DisplayOnNativeOther': {},
    'fwk-ads-exp2-DisplayOnNativeInbox': {},
    'fwk-ads-exp2-ByPassNewUserCheck': {},
    'fwk-ads-kill-GdprPrebid': {
        description: 'Kill switch to stop sending the gdpr information to the prebid process',
    },
    'fwk-ads-noAol-all': {},
    'fwk-ads-noAol-eight-exceptBr': {},
    'fwk-batchSubscriptions': {},
    'fwk-bookingsModule': {},
    'fwk-cobranding': {},
    'fwk-consumerWaffle': {},
    'fwk-darkTheme': {},
    'fwk-devTools': {},
    'fwk-emptyPost': {},
    'fwk-errorHandlerNonWrapped': {},
    'fwk-errorpopup': {},
    'fwk-exportMailboxOption': {},
    'fwk-feedbackCharm': {},
    'fwk-fluentCommandBar': {},
    'fwk-fluentCommandBar-dropdowns': {},
    'fwk-gdprAdsPrefs': {},
    'fwk-getAllowedOptions': {
        description:
            'Flight to indicate whether to call GetAllowedOptions to determine what options to show or hide.',
    },
    'fwk-hipExceptionRedirect': {},
    'fwk-improvedExceptionHandler': {},
    'fwk-inAppNotifications': {},
    'fwk-localeHotReload': {},
    'fwk-moduleSwitcherReuseTab-all': {},
    'fwk-moduleSwitcherReuseTabs': {},
    'fwk-nativeAds-appNexusOneClick': {},
    'fwk-nativeAds-appNexusOneClickOtherInboxOnly': {},
    'fwk-nativeAds-appNexusTwoClick': {},
    'fwk-nativeAds-bingOneClick': {},
    'fwk-nativeAds-bingOneClickForceViewTracker': {},
    'fwk-nativeAds-bingPrebid': {},
    'fwk-nativeAds-bingOneClickOtherInboxOnly': {},
    'fwk-nativeAds-bingTwoClick': {},
    'fwk-nativeAds-bingTwoClickOtherInboxOnly': {},
    'fwk-nativeAds-honorEasyOtherOffKillSwitch': {},
    'fwk-nativeAds-prebidOneClickAllInbox': {},
    'fwk-nativeAds-prebidOneClickOtherInboxOnly': {},
    'fwk-nativeads-disableIcons': {},
    'fwk-nativeads-fanFillNobid': {},
    'fwk-o365shellheader': {},
    'fwk-o365shellheader-responsive': {},
    'fwk-option-popImap': {},
    'fwk-partner-code-off': {},
    'fwk-patchSignalRGetUrl': {},
    'fwk-peopleReact': {},
    'fwk-perf-fps': {},
    'fwk-performanceCharm': {},
    'fwk-politeServiceErrors': {},
    'fwk-prefetch-code-off': {},
    'fwk-prefetch-data-off': {},
    'fwk-proxyOwsPrime': {},
    'fwk-puidBasedRouting': {
        description:
            'uses PUID:<puid>@tenant as routing hint instead of reading from cookie. This applies to requests made through makeServiceRequest typically used to hit Model B services',
    },
    'fwk-sigs': {},
    'fwk-skypeBusiness': {},
    'fwk-skypeBusinessV2': {
        description: 'Support UCMA/UCWA/Teams client for business user',
    },
    'fwk-skypeBusiness-ucmadebug': {
        description:
            'Force using UCMA even user is set to use UCWA/Teams, this is for debugging only',
    },
    'fwk-skypeConsumer': {},
    'fwk-skypeSettingsMigration': {},
    'fwk-skypeSuite': {
        description:
            'Flight to control whether the O365 Suite Header takes control of initializing Skype',
    },
    'fwk-skypeBusinessCalling': {},
    'fwk-themes-edu': {
        description: 'Whether to show new themes to EDU tenants',
    },
    'fwk-turnOffCustomData': {},
    'fwk-useJsonNetSerializer': {},
    'fwk-webNotification': {},
    'fwk-webPushNotification': {},
    'fwk-webPushNotificationSignout': {
        description: 'Unsubscribe web push notification on explicit signout',
    },
    'fwk-webPushNotificationV2': {},
    'grp-NativeConnectorsPortalEnabled': {
        description: 'If enabled, Connectors portal will be opened in a modal',
    },
    'grp-consumerGroupFilesInGroupHub': {},
    'grp-junkemailitems': {
        description:
            'Display items from Junk Email folder instead of Inbox on group view. Used for debugging purposes only. Only works for item view.',
    },
    'grp-discovery-leftnav': {
        description: 'Enables the Groups Discover workflow',
    },
    'grp-echoSuppressionOption': {},
    'grp-manage-leftnav': {
        description: 'Enables the Groups Hub entry',
    },
    'grp-groupFileshubFRE': {
        description: 'If enabled, shows FRE callouts in Group files hub',
    },
    'grp-groupHeaderV2': {},
    'grp-prefetchSPTokenFromConversations': {
        description: 'If enabled, prefetches token in conversation space',
    },
    'grp-screenshotAutomationTest': {},
    'grp-unreadCountTop5AndFavorites': {},
    'grp-warmUpFrequentlyUsedGroups': {},
    'grp-shareable-crud': {},
    'grp-suggestUnifiedGroupMembers': {
        description: 'suggestUnifiedGroupMembers API for consumer groups',
    },
    'gsx-translator-translateMessage': {},
    'help-disableTicketFlow': {},
    'help-miniMavenWidget': {},
    'help-o365ShellHeader-MaxPane': {},
    'help-proactiveMessaging': {},

    'inline-feature-feedback': {},

    'lpc-isInBlackforest': {
        description: 'Indicates that the user is in a blackforest tenant',
    },
    'lpc-isInGccModerate': {
        description: 'Indicates that the user is in a GCC-moderate tenant',
    },
    'mailto-group-forms': {
        description: 'Launch group forms via mailto link',
    },
    'mc-botConversation': {},
    'mc-confetti': {},
    'mc-cortanaCompose': {},
    'mc-contextualSuggestionsCompose': {
        description: 'Enables making a service call for contextual suggestions in compose',
    },
    'mc-contextualSuggestionsComposeExp': {
        description:
            'Enables making a service call for contextual suggestions in compose using experimental model',
    },
    'mc-imageDiagnostics': {},
    'mc-imageSxS': {},
    'mc-logMessagesInSpanish': {
        description:
            'Temporary flight to log messages in Spanish, to see if smart reply for Spanish is a worthwhile endeavor',
    },
    'mc-moveAttachmentToInline': {},
    'mc-replyWith': {
        description: 'If enabled, we retrieve contextual attachments and MRU cloudy attachments',
    },
    'mc-replyWithNAMPrime': {
        description:
            'Equivalent to mc-replyWith, but meant for testing impact of attachment suggestions on non-NAM regions',
    },
    'mc-replyWithMRUClassic': {
        description: 'If enabled, we retrieve MRU classic attachments',
    },
    'mc-replyWithMRUCloudy': {
        description: 'If enabled we retrieve MRU cloudy attachments',
    },
    'mc-replyWithMRUCloudyLimited': {
        description:
            'If enabled, we ensure that the MRU service returns at most one cloudy attachment, the rest being classic. For testing purposes only.',
    },
    'mc-replyWithContextual': {
        description:
            'If enabled, we retrieve contexutal attachment suggestions (ranked by AI model)',
    },
    'mc-replyWithContextualMRU': {
        description:
            'If enabled, we retrieve contexutal attachment suggestions (ordered by last access date)',
    },
    'mc-smartCompose': {},
    'mc-smartComposeExp': {
        description: 'Use experimental model for Smart Compose suggestions',
    },
    'mc-smartReplyWithDoc': {},
    'mc-smartPillsCompose': {
        description: 'Controls showing smart pills in compose',
    },
    'mc-smartPillsFeedbackForm': {
        description: 'New feedback UX for smart pills (yes/no only)',
    },
    'mc-smartPillsFeedbackFormV2': {
        description: 'New feedback UX for smart pills (yes/no and modal)',
    },
    'mc-smartPillsMessageView': {},
    'mc-smartReply': {},
    'mc-smartReplySpanishMexico': {
        description: 'Enables smart reply (text only) in messages that are in Mexican Spanish',
    },
    'mc-smartReplyWithCustomMeeting': {},
    'mc-smartReplyWithMeeting-SuggestedTimeToCAS': {
        description: 'Enable sending specific time suggestion to CAS for smart reply with meeting',
    },
    'mc-smartPillConfidenceLevel_MID': {
        description: 'Enable smart-* pill when confidence score is at the mid level (ex: 80%)',
    },
    'mc-smartPillConfidenceLevel_LOW': {
        description: 'Enable smart-* pill when confidence score is low (ex: 70% or below)',
    },
    'mc-smartTask': {
        description: 'Controls showing smart task (ex: todo)',
    },
    'mc-smartTaskWithReminder': {
        description: 'Controls showing smart task with reminder',
    },
    'mc-smartSuggestions': {},
    'mc-userHighlighting': {},
    'mc-voting': {
        description: 'Enables the owa mail voting feature',
    },
    'nps-fms': {},
    'peo-ev-header': {},
    'peo-favoritePdls': {
        description: 'Enables Private Distribution Lists favorites',
    },
    'peo-lokiDogfood': {},
    'peo-lpcTargetV2OnPersonaCardBehavior': {
        description: 'PersonaCardBehavior uses LivePersonaCardTargetV2 when this feature is on',
    },
    'peo-subjectPicker': {},
    'peo-unauthenticatedSender': {},
    'people-contactCleanupEnterprise': {},
    'people-favoritePicker': {
        description: 'Enables picker in Favorites list in PeopleHub',
    },
    'people-favoritePickerIncludeGroups': {
        description:
            'Groups will be included in picker in Favorites list in PeopleHub. Works if people-favoritePicker flight is enabled',
    },
    'people-emptyFolder-bulk': {
        description: 'Enables loader in any HubList to display a progress of EmptyFolder operation',
    },
    'people-initialGroupsPrefetch': {},
    'people-restoreDeletedItemsFolders': {
        description: 'Adds an option to restore whole folder from leftNav in PeopleHub',
    },
    'people-groupsPrefetch': {},
    'people-searchTypeLabels': {
        description:
            'Enables labels with contact source information in Search Results in PeopleHub',
    },
    'people-suggestionFolder': {},
    'people-publicFolders': {
        description: 'Enables Public Folders support for PeopleHub, only available in Enterprise',
    },
    'people-option-displayby': {
        description: 'Control "Display by" from Settings page',
    },
    'people-groupsDeeplink': {},
    'people-pdlsInCommandBar': {
        description:
            'Enables Dropdown in CommandBar in PeopleHub to add/remove Contacts to ContactLists',
    },
    'people-groupRestoreOnGroupMailbox': {
        description: 'Add the headers in Restore group ows call to land on group mailbox',
    },
    'pf-favorite': {
        description: 'Shows public folder favorites in left-nav',
    },
    'pf-picker': {},
    'pf-picker-calendar': {},
    'pf-post': {},
    'ring-dogfood': {},
    'ring-microsoft': {},
    'ring-firstrelease': {},
    'ring-ww': {},
    'rp-3SLocalSearchRanking': {},
    'rp-3SPeopleSuggestions': {},
    'rp-acDisableTransactionCard': {
        description: 'Disables the transaction card',
    },
    'rp-acTUIBubble': {
        description: 'Adds Teaching Bubble teaching UI to Actionable Message RP',
    },
    'rp-actionableMessages': {},
    'rp-actionableMessages-respect-smtpActionableMessagesEnabled': {},
    'rp-actionableMessages-aad-token': {},
    'rp-actionableMessages-contextual': {},
    'rp-actionableMessages-lpc': {},
    'rp-actionableMessages-myanalytics': {},
    'rp-actionableMessages-msa-token': {},
    'rp-adaptiveCardsRecordLinks': {
        description: 'Enables the logging of links on AdaptiveCards',
    },
    'rp-addins': {},
    'rp-amp': {},
    'rp-appendOnSend': {},
    'rp-brandCards': {},
    'rp-brandCardsUnsubscribe': {},
    'rp-brandDecorations': {},
    'rp-calendarRollup': {},
    'rp-calendarRollupDetailCard': {},
    'rp-collapsedItemsRollUp': {},
    'rp-csaExp': {},
    'rp-csaExpWithMenuIcons': {},
    'rp-customSurfaceActions': {},
    'rp-externalImagesProxyOption': {},
    'rp-findPeopleSuggestionFeedback': {},
    'rp-floatingActionBar': {},
    'rp-immersiveReader': {},
    'rp-immersiveReaderDogfood': {},
    'rp-infoBarBrandSubscription': {
        description: 'Enable Unsubscribe from Infobar',
    },
    'rp-inlineTranslation': {
        description: 'Enables inline translation of messages in reading pane',
    },
    'rp-inlineTranslationForwardContent': {
        description: 'Enables inline translation of forward content messages in reading pane',
    },
    'rp-inlineTranslationAutomatic': {
        description: 'Enables automatic inline translation of messages in the reading pane',
    },
    'rp-inlineTranslationManual': {
        description: 'Enables manual entry point for inline translation',
    },
    'rp-imageApiConsumer': {},
    'rp-isSentOnBehalfOf': {},
    'rp-lastActionInfoBar': {
        description: 'Infobar to show last action of the user on an item',
    },
    'rp-like': {},
    'rp-linkedInPeopleSuggestions': {},
    'rp-livePersonaCard': {},
    'rp-newTabLook': {
        description: 'Enabled the new tab look, including the merging of Skype and OWA tab systems',
    },
    'rp-oofRollup': {},
    'rp-opay-modelb-endpoint': {},
    'rp-outlookAddinsDeeplink': {},
    'rp-peopleSuggestionsCacheFirst': {},
    'rp-popoutsDebug': {
        description: 'When this feature is on, popout data from local storage will not be cleared',
    },
    'rp-prague': {
        description:
            'Enables the prague content handler, a plugin that detects prague links and embeds them into the reading pane surface.',
    },
    'rp-readReceipt': {
        description: 'Shows actionable infobar for user enabled read receipt',
    },
    'rp-replyByMeeting': {},
    'rp-replyImageProxy': {},
    'rp-requestPersonaResponseShape': {},
    'rp-safetyMessage': {},
    'rp-selectionUI': {},
    'rp-skypeInTabs': {
        description: 'Feature flag that controls if skype should be put into tabs managed by OWA.',
    },
    'rp-smartTime': {},
    'rp-smime': {},
    'rp-tabView': {},
    'rp-wideContent': {},
    'rp-imageContentHandler': {},
    'rp-localLieSentTime': {},
    'rp-yammer': { description: 'Shows rich Yammer content for select Yammer messages' },
    'sea-advanced-search': {
        description:
            'If on, the revamped advanced search UI will be used to control search refiners.',
    },
    'sea-archive-mailbox-3S': {
        description: 'Search archive mailbox using 3S',
    },
    'sea-categoryClientSuggestions': {
        description: 'Shows category suggestions on search typedown',
    },
    'sea-circlePersonas': {},
    'sea-contextFeedback': {},
    'sea-debugHook': {},
    'sea-emailSuggestions': {
        description: 'Shows email message suggestions on search typedown',
    },
    'sea-explicitLogon3S': {
        description: 'When enabled, use 3S search for searching in explicit logon scenario.',
    },
    'sea-fileCommands': {
        description: 'Show file commands in command mode',
    },
    'sea-fileSuggestionAugmentation': {
        description: 'Show quick action buttons on file suggestions from search',
    },
    'sea-filesSuggestions': {
        description: 'Shows files suggestions on search typedown',
    },
    'sea-floodgateSurvey': {
        description: 'Floodgate survey for search scenarios',
    },
    'sea-floodgateSurveySDFSampling': {
        description: 'Floodgate survey flag to indicate SDF different sampling',
    },
    'sea-gdpr': {},
    'sea-gf': {
        description: 'Enables GF (advanced suggestions) in the search box',
    },
    'sea-gf1': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf2': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf3': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf4': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf5': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gf6': {
        description:
            'Enables GF (advanced suggestions) in the search box. See WI 40315 for more information about flight configuration.',
    },
    'sea-gfct1': {
        description:
            'Control flight for GF (advanced suggestions) experiment. See WI 40315 for more information about flight configuration.',
    },
    'sea-ghostText': {
        description: 'Shows ghost text in search input and allows for autocompletion.',
    },
    'sea-highlightAttachments': {
        description:
            'Highlights matching keywords in attachment names in search results (list view and RP).',
    },
    'sea-hybridSearchSupported': {
        description:
            'This flight is enabled for environments where hybrid search (for ExecuteSearch) is supported.',
    },
    'sea-inlineFeedback': {
        description: 'Update search inline feedback control',
    },
    'sea-initAsQuery': {},
    'sea-personaCardInSuggestions': {
        description: 'Shows persona card in the suggestions on hover of which we shall open LPC',
    },
    'sea-pillHighlight': {
        description: 'Remove pill text from hit highlighting',
    },
    'sea-prefixHH': {
        description: 'Hit highlight based off prefix instead of substring',
    },
    'sea-proxy3SQuery': {},
    'sea-qf': {},
    'sea-queryTextKQL': {
        description: 'Retain queryText from server suggestion for people pill KQL',
    },
    'sea-resultInstrumentation': {},
    'sea-searchBoxInteractions1': {
        description: 'Treatment 1 for search box interactions experiment',
    },
    'sea-searchBoxInteractionsClear': {
        description: 'Gates the clear search box button visiblity',
    },
    'sea-searchHistoryApi': {
        description:
            "If enabled, we'll make requests to new SearchHistory API when deleting/exporting search history.",
    },
    'sea-sendPillDisplayText': {
        description:
            'Prepends pills (using their DisplayText) to the query text sent in suggestions calls.',
    },
    'sea-skipOwsPrime': {},
    'sea-spellingCorrectedSearchNoResults': {
        description: 'If enabled, we show "no results" specific speller UX.',
    },
    'sea-substrateQuery': {},
    'sea-zinq-3s2': {
        description: 'Fetch zero-input no-query suggestions from 3S.',
    },
    'sea-zinq-3sctr2': {
        description:
            'Custom control for 3S powered zero input flight.  Sends a request to 3S to suggestions but renders local suggestions.',
    },
    'cal-time-panel': {},
    'todo-panel': {},
    'todo-flagged-email-list': {},
    'tra-cacheTranslation': {
        description: 'Allow translation of items to be stored as extended property.',
    },
    'tra-EnableShortMessage': {
        description: 'Allow short messages to be translated.',
    },
    'tri-anchorMailboxHeader': {},
    'tri-archive-mailbox': {
        description: 'Archive Mailbox Feature to be used in owa-mail',
    },
    'tri-coupon-peek': {},
    'tri-density-controls': {
        description: 'Full, Simple, Compact option in density controls',
    },
    'tri-conversationView-folderTags': {
        description: 'Folder tags in conversation view',
    },
    'tri-hoverIconsUI': {
        description: 'UI update for hover icons',
    },
    'tri-favoriteSearch': {},
    'tri-favorites-roaming': {
        description: 'Enables Roaming favorites served from Prime endpoint.',
    },
    'tri-filterMenuRedesign': {
        description: 'Redesigned filter / sort menu',
    },
    'tri-flag-complete': {
        description: 'Show flag complete menu in list view right click menu',
    },
    'tri-folderPermissions': {
        description: 'Add folder permissions feature',
    },
    'tri-inbox-plus-v1': {
        description: 'Inbox plus feature in owa-mail',
    },
    'tri-leftNavWidthFull': {
        description:
            'Default users in this treatment to 284px so that they can see all module switcher buttons',
    },
    'tri-meetingMessageRSVP': {
        description: 'Allows user to initiate meeting actions from the ListView',
    },
    'tri-moduleSwitcherBehavior': {
        description: 'Open workload in same tab instead of new tab',
    },
    'tri-notificationBar': {
        description: 'Show notifications for specific triage actions (move/archive/delete)',
    },
    'tri-nudge': {
        description:
            'bring email that users may have missed to read or forgotten to follow up to the top of list view',
    },
    'tri-pauseInbox': {
        description: 'Stop incoming mail from coming into inbox',
    },
    'tri-persistSort': {
        description: 'Persisting sort order per folder based on JSMVVM settings',
    },
    'tri-reportAbuse': {
        description: 'Adds report abuse action to ListView and ReadingPane drop down',
    },
    'tri-retentionPolicies': {
        description: 'Adds triage action of assigning policy for folders, mail items',
    },
    'tri-scrollMoreDataPoint': {
        description: 'Logging to determine how far users scroll down list view',
    },
    'tri-searchBackstacking': {
        description: 'Fixing search backstacking',
    },
    'tri-sharedFolders': {
        description: 'Add shared folders feature',
    },
    'tri-smartMergeFindResponse': {
        description:
            'Merges the FindConv/FindItem with the cached response data only if the lastModifiedTime changed',
    },
    'tri-snooze': {
        description: 'Adds snooze feature to delay message delivery.',
    },
    'tri-snooze-exp': {
        description: 'Adds snooze string for experiments.',
    },
    'tri-spamV2': {
        description: 'Controls Reporting and Filtering spam v2 settings',
    },
    'tri-spamV2SenderDomain': {
        description: 'Controls blocked/safe senders and domains spam v2 settings',
    },
    'tri-superJunkSettings': {
        description: 'Adds additional functionality to the junk options page and notifications',
    },
    'tri-suppressMarkReadBehaviorOnRF': {
        description: 'When enabled we shall suppress the mark read server behavior upon r/R/F',
    },
    'tri-sweepBulkAction': {
        description:
            'Controls whether bulk actions payloads will be sent from the server for sweep',
    },
    'tri-triageFolderScope': {
        description:
            'When enabled triage actions are performed at folder scope context (and at search folder scope when disabled)',
    },
    'tri-turnOffFocusedOther': {
        description: 'Adds a dialog in the mail list header to prompt user to turn off FO',
    },
    'tri-autoMarkReadInUnreadSetting': {
        description: 'Adds setting to support auto mark as read in the unread filter',
    },
    'tri-upNext': {},
    'tri-upNextV2': {
        description: 'Display the upcoming event in the commanding bar',
    },
    'tri-virtualizedListView': {
        description: 'Remove the inner divs of mail list item when item is scrolled out of view',
    },
    'usv-forum': {},
    'usv-nps': {},
    'usv-nps-5-rating-scale': {},
    'whatsNew-Pane': {},
    'whatsNew-Pane-Fluent': {},
    'getStarted-ListView': {},
    'getStarted-FlexPane': {},
};

export default features;
export type FeatureName = Extract<keyof typeof features, string>;
